// Mock data for AB Nail Lounge

export const siteContent = {
  fr: {
    nav: {
      home: 'Accueil',
      about: 'À propos',
      services: 'Services',
      gallery: 'Galerie',
      booking: 'Réservation',
      contact: 'Contact'
    },
    hero: {
      title: 'AB Nail Lounge',
      subtitle: 'L\'Art de la Beauté des Ongles',
      description: 'Découvrez une expérience unique de soins des ongles avec Anastasiya, nail master passionnée à Moncton.',
      cta: 'Réserver maintenant'
    },
    about: {
      title: 'À propos de moi',
      subtitle: 'Anastasiya - Nail Master',
      description: 'Bonjour✨ Je suis Anastasiya, une Nail Master passionnée à Moncton. Avec plusieurs années d\'expérience en manucure et service d\'ongles en gel, je crée des designs personnalisés pour chaque cliente. Mon objectif est de m\'assurer que vous repartez avec de beaux ongles et que vous vous sentiez détendue, rafraîchie et choyée.',
      experience: 'Expérience',
      clients: 'Clientes satisfaites',
      designs: 'Designs créés'
    },
    services: {
      title: 'Services Offerts',
      subtitle: 'Des soins de qualité pour des ongles parfaits',
      items: [
        {
          id: 1,
          name: 'Manucure Hygiénique',
          description: 'Soin complet des ongles sans couleur - mise en forme et cuticules.',
          price: '30$',
          duration: '45 min'
        },
        {
          id: 2,
          name: 'Manucure Shellac',
          description: 'Manucure avec couleur (1 couleur incluse) pour un résultat durable.',
          price: '60$',
          duration: '90 min'
        },
        {
          id: 3,
          name: 'Gel Overlay',
          description: 'Renforcement sur ongles naturels (1 couleur incluse).',
          price: '70$',
          duration: '2 heures'
        },
        {
          id: 4,
          name: 'Extensions Gel',
          description: 'Extensions courtes, moyennes ou longues (1 couleur incluse).',
          price: '95$',
          duration: '3-4 heures'
        },
        {
          id: 5,
          name: 'Designs',
          description: 'Designs personnalisés et créatifs pour exprimer votre style.',
          price: '5$ - 10$',
          duration: 'Variable'
        },
        {
          id: 6,
          name: 'French Design',
          description: 'Design French classique et élégant.',
          price: '+5$',
          duration: 'Variable'
        }
      ]
    },
    gallery: {
      title: 'Galerie',
      subtitle: 'Découvrez mes réalisations',
      viewMore: 'Voir plus sur Instagram',
      categories: ['Tous', 'Gel', 'Nail Art', 'Classique']
    },
    booking: {
      title: 'Réservation',
      subtitle: 'Prenez rendez-vous facilement via WhatsApp',
      description: 'Cliquez sur le bouton ci-dessous pour m\'envoyer un message WhatsApp et réserver votre prochain rendez-vous.',
      cta: 'Réserver via WhatsApp',
      hours: 'Heures d\'ouverture',
      schedule: [
        { day: 'Lundi', hours: '9h - 18h' },
        { day: 'Mardi', hours: '9h - 18h' },
        { day: 'Mercredi', hours: '9h - 18h' },
        { day: 'Jeudi', hours: '9h - 18h' },
        { day: 'Vendredi', hours: '9h - 18h' },
        { day: 'Samedi', hours: '9h - 16h' },
        { day: 'Dimanche', hours: 'Fermé' }
      ]
    },
    contact: {
      title: 'Contact',
      subtitle: 'Restons en contact',
      address: '44 Mapleton Rd., suite 202',
      city: 'Moncton, NB',
      building: 'Lawtons building, 2nd floor',
      phone: '+1 902 330 9192',
      email: 'contact@abnaillounge.ca',
      instagram: '@ab.naillounge'
    },
    footer: {
      rights: 'Tous droits réservés',
      location: 'Supreme Beauty & Wellness',
      privacy: 'Politique de confidentialité'
    },
    whatsappMessages: {
      manicure: 'Bonjour Anastasiya! Je souhaite réserver une manucure classique. Quelles sont vos disponibilités?',
      extensions: 'Bonjour Anastasiya! Je suis intéressée par des extensions gel. Pouvez-vous me donner plus d\'informations?',
      refill: 'Bonjour Anastasiya! J\'aimerais prendre rendez-vous pour un remplissage.',
      bridal: 'Bonjour Anastasiya! Je me marie bientôt et je cherche une manucure pour le grand jour. Pouvez-vous m\'aider?',
      general: 'Bonjour Anastasiya! Je souhaite prendre rendez-vous pour un soin des ongles.'
    }
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      gallery: 'Gallery',
      booking: 'Booking',
      contact: 'Contact'
    },
    hero: {
      title: 'AB Nail Lounge',
      subtitle: 'The Art of Nail Beauty',
      description: 'Discover a unique nail care experience with Anastasiya, passionate nail master in Moncton.',
      cta: 'Book Now'
    },
    about: {
      title: 'About Me',
      subtitle: 'Anastasiya - Nail Master',
      description: 'Hello✨ I\'m Anastasiya, a passionate Nail Master in Moncton. With several years of experience in manicures and gel nail service, I create custom designs for every client. My goal is to make sure you leave with beautiful nails and feel relaxed, refreshed, and cared for.',
      experience: 'Experience',
      clients: 'Happy clients',
      designs: 'Designs created'
    },
    services: {
      title: 'Offered Services',
      subtitle: 'Quality care for perfect nails',
      items: [
        {
          id: 1,
          name: 'Hygienic Manicure',
          description: 'Complete nail care without color - shaping and cuticles.',
          price: '$30',
          duration: '45 min'
        },
        {
          id: 2,
          name: 'Shellac Manicure',
          description: 'Manicure with color (1 color included) for a lasting result.',
          price: '$60',
          duration: '90 min'
        },
        {
          id: 3,
          name: 'Gel Overlay',
          description: 'Reinforcement on natural nails (1 color included).',
          price: '$70',
          duration: '2 hours'
        },
        {
          id: 4,
          name: 'Gel Extensions',
          description: 'Short, medium or long extensions (1 color included).',
          price: '$95',
          duration: '3-4 hours'
        },
        {
          id: 5,
          name: 'Designs',
          description: 'Custom and creative designs to express your style.',
          price: '$5 - $10',
          duration: 'Variable'
        },
        {
          id: 6,
          name: 'French Design',
          description: 'Classic and elegant French design.',
          price: '+$5',
          duration: 'Variable'
        }
      ]
    },
    gallery: {
      title: 'Gallery',
      subtitle: 'Discover my work',
      viewMore: 'See more on Instagram',
      categories: ['All', 'Gel', 'Nail Art', 'Classic']
    },
    booking: {
      title: 'Booking',
      subtitle: 'Book easily via WhatsApp',
      description: 'Click the button below to send me a WhatsApp message and book your next appointment.',
      cta: 'Book via WhatsApp',
      hours: 'Opening Hours',
      schedule: [
        { day: 'Monday', hours: '9am - 6pm' },
        { day: 'Tuesday', hours: '9am - 6pm' },
        { day: 'Wednesday', hours: '9am - 6pm' },
        { day: 'Thursday', hours: '9am - 6pm' },
        { day: 'Friday', hours: '9am - 6pm' },
        { day: 'Saturday', hours: '9am - 4pm' },
        { day: 'Sunday', hours: 'Closed' }
      ]
    },
    contact: {
      title: 'Contact',
      subtitle: 'Let\'s stay in touch',
      address: '44 Mapleton Rd., suite 202',
      city: 'Moncton, NB',
      building: 'Lawtons building, 2nd floor',
      phone: '+1 902 330 9192',
      email: 'contact@abnaillounge.ca',
      instagram: '@ab.naillounge'
    },
    footer: {
      rights: 'All rights reserved',
      location: 'Supreme Beauty & Wellness',
      privacy: 'Privacy Policy'
    },
    whatsappMessages: {
      manicure: 'Hello Anastasiya! I would like to book a classic manicure. What are your availabilities?',
      extensions: 'Hello Anastasiya! I\'m interested in gel extensions. Can you give me more information?',
      refill: 'Hello Anastasiya! I would like to make an appointment for a refill.',
      bridal: 'Hello Anastasiya! I\'m getting married soon and looking for a manicure for the big day. Can you help me?',
      general: 'Hello Anastasiya! I would like to make an appointment for nail care.'
    }
  }
};

export const galleryImages = [
  {
    id: 1,
    src: 'https://customer-assets.emergentagent.com/job_nailsbymoncton/artifacts/edl45clf_WhatsApp%20Image%202025-12-14%20%C3%A0%2000.02.26_4490f7b9.jpg',
    category: 'Nail Art',
    alt: 'Valentine French tips with hearts and bunny charms'
  },
  {
    id: 2,
    src: 'https://customer-assets.emergentagent.com/job_nailsbymoncton/artifacts/cqyg8peo_WhatsApp%20Image%202025-12-14%20%C3%A0%2000.02.25_c96d411a.jpg',
    category: 'Gel',
    alt: 'Turquoise ombre with gold accents'
  },
  {
    id: 3,
    src: 'https://customer-assets.emergentagent.com/job_nailsbymoncton/artifacts/gkd4h5ei_WhatsApp%20Image%202025-12-14%20%C3%A0%2000.02.25_22c269d9.jpg',
    category: 'Nail Art',
    alt: 'Leopard print and chocolate French design'
  },
  {
    id: 4,
    src: 'https://customer-assets.emergentagent.com/job_nailsbymoncton/artifacts/xqxdb9ba_WhatsApp%20Image%202025-12-14%20%C3%A0%2000.02.25_55a8747e.jpg',
    category: 'Gel',
    alt: 'Sage green French tips with gold stars'
  },
  {
    id: 5,
    src: 'https://customer-assets.emergentagent.com/job_nailsbymoncton/artifacts/3hhjr8f3_WhatsApp%20Image%202025-12-14%20%C3%A0%2000.02.25_454d3995.jpg',
    category: 'Classic',
    alt: 'Pink glitter natural nails'
  },
  {
    id: 6,
    src: 'https://customer-assets.emergentagent.com/job_nailsbymoncton/artifacts/jsoe717o_WhatsApp%20Image%202025-12-14%20%C3%A0%2000.02.25_1430ed92.jpg',
    category: 'Nail Art',
    alt: 'Periwinkle blue with floral design'
  },
  {
    id: 7,
    src: 'https://customer-assets.emergentagent.com/job_nailsbymoncton/artifacts/skeidhar_WhatsApp%20Image%202025-12-14%20%C3%A0%2000.02.25_c7bebc5b.jpg',
    category: 'Nail Art',
    alt: 'Christmas gingerbread and snowflakes design'
  },
  {
    id: 8,
    src: 'https://customer-assets.emergentagent.com/job_nailsbymoncton/artifacts/3e47jrkn_WhatsApp%20Image%202025-12-14%20%C3%A0%2000.02.25_c7fbf841.jpg',
    category: 'Classic',
    alt: 'Soft pink with white floral art'
  }
];

export const whatsappNumber = '19023309192';

export const instagramHandle = 'ab.naillounge';

export const businessInfo = {
  name: 'AB Nail Lounge',
  owner: 'Anastasiya',
  location: 'Supreme Beauty & Wellness',
  address: '44 Mapleton Rd., suite 202',
  city: 'Moncton, NB',
  building: 'Lawtons building, 2nd floor',
  phone: '+1 902 330 9192',
  instagram: 'https://www.instagram.com/ab.naillounge/',
  whatsapp: 'https://wa.me/19023309192'
};
